import MetaphiIcon from 'app/components/icons/MetaphiIcon';
import NasLogo from 'app/components/icons/NasLogoIcon';
import Loading from 'app/components/Loading';
import Modal from 'app/components/Modal';
import { metaphiUrl } from 'app/constants/constant';
import useCountdown from 'app/hooks/useCountdown';
import React, { useEffect } from 'react';
import style from './CodeEntryModal.module.scss';
import DividedCodeInput from './partials/DividedCodeInput';

type CodeEntryModalProps = {
  email?: string;
  open: boolean;
  onContact?: (...args: any[]) => void;
  onResendOtp?: (...args: any[]) => void;
  onSuccess?: (...args: any[]) => void;
  onChange?: (...args: any[]) => void;
  onClose?: (...args: any[]) => void;
  isLoading?: boolean;
  error?: string;
};

const CodeEntryModal = ({
  email,
  open,
  onContact,
  onResendOtp,
  onSuccess,
  onChange,
  isLoading,
  error,
  onClose,
}: CodeEntryModalProps) => {
  const className = 'c-CodeEntryModal';

  const { isRunning, counter, startCountdown, resetCountdown } = useCountdown({
    seconds: 30,
  });

  const countdownText = isRunning ? `Resend code (${counter})` : 'Resend code';
  const countdownClassName = [
    style[`${className}__body__countdown`],
    !isRunning ? style[`${className}__body__countdown--stopped`] : null,
  ].join(' ');

  const onCountdownClick = () => {
    if (isRunning) return;

    onResendOtp?.();
    resetCountdown();
    startCountdown();
  };

  useEffect(() => {
    startCountdown();
  }, [startCountdown]);

  return (
    <Modal
      open={open}
      showCloseIcon={false}
      onClose={onClose}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <div className={style[`${className}__logo`]}>
          <NasLogo />
        </div>
        <div className={style[`${className}__body`]}>
          <p className={style[`${className}__body__title`]}>
            Enter the 6-digit code emailed to
          </p>
          <p className={style[`${className}__body__subtitle`]}>{email}</p>
          <div className={style[`${className}__body__code`]}>
            <DividedCodeInput
              onSuccess={onSuccess}
              onChange={onChange}
              error={error}
            />
          </div>
          <p className={style[`${className}__body__text`]}>
            Code arriving in a few seconds
          </p>
          <p className={countdownClassName} onClick={onCountdownClick}>
            {countdownText}
          </p>
          <p className={style[`${className}__body__contact`]}>
            Having issues? <span onClick={onContact}>Contact us</span>
          </p>
        </div>
        <div className={style[`${className}__footer`]}>
          Powered by
          <a href={metaphiUrl} target="_blank" rel="nooppener noreferrer">
            <MetaphiIcon />
            <span>Metaphi</span>
          </a>
        </div>
        {isLoading && (
          <div className={style[`${className}__loading`]}>
            <Loading />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CodeEntryModal;
